module.exports = __webpack_public_path__ + "static/media/SDFSA_5-634w.7cd0894d.jpg";